export const LOAD_HOME_DATA = "LOAD_HOME_DATA";
export const QUICK_FORM_CHANGED = "QUICK_FORM_CHANGED";
export const RESET_QUICK_FORM = "RESET_QUICK_FORM";
